import { css } from '@emotion/react'
import { breakpoint, size, width } from '@twistopayments/design-system/styles'

export const section = css`
  display: flex;
  flex-direction: column;
  gap: ${size[32]};

  h2,
  p {
    margin: 0;
  }

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    align-items: center;
    gap: ${size[64]};
    max-width: ${width.container.wider};
    margin: 0 auto;
  }
`

export const content = css`
  width: 100%;
  padding: 0 ${size[24]};

  ${breakpoint.up('smMd')} {
    padding: 0;
  }
`

export const imageWrapper = css`
  position: relative;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    transition: background-color 0.3s ease-out;
    background: linear-gradient(
      270.01deg,
      rgba(32, 22, 43, 0.052) 33.04%,
      rgba(69, 13, 135, 0.52) 99.99%
    );
  }

  ${breakpoint.up('smMd')} {
    height: 524px;
    max-width: 550px;
    width: 100%;

    &::after,
    img {
      border-radius: 0 ${size[36]} 0 ${size[36]};
    }
  }
`

export const rightPanel = css`
  display: flex;
  flex-direction: column;
  gap: ${size[32]};
  max-width: ${width.container.standard};

  ${breakpoint.up('smMd')} {
    gap: ${size[48]};
  }
`

export const cta = css`
  margin: 0 ${size[24]};

  ${breakpoint.up('smMd')} {
    width: fit-content;
    margin: 0;
    padding: 0 ${size[64]};
  }
`
